import { Component } from '@angular/core';
import {TranslocoPipe} from "@jsverse/transloco";
import {UpperCasePipe} from "@angular/common";
import {LabelComponent} from "~/app/shared/components/elements/label/label.component";

@Component({
    selector: 'eb-new-tag',
    templateUrl: './new-tag.component.html',
    imports: [
        TranslocoPipe,
        UpperCasePipe,
        LabelComponent
    ],
    styleUrl: './new-tag.component.scss'
})
export class NewTagComponent {

}
